export default "__VITE_ASSET__BVJ2ykrS__"